// import _ from 'lodash'

import Vue from 'vue';
import VueApollo from 'vue-apollo';
import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { from } from 'apollo-link';
// import { ApolloLink, from } from 'apollo-link'
import { onError } from 'apollo-link-error';
import { InMemoryCache } from 'apollo-cache-inmemory';

import store from '@/store';
// import router from '@/router'

import get from 'lodash.get';
import trimEnd from 'lodash.trimend';

const ENDPOINT = `${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_GRAPHQL_ROUTE}`;
const httpLink = new HttpLink({ uri: trimEnd(ENDPOINT, '/') });

const networkErrorLink = onError((parent) => {
    const { networkError, graphQLErrors, operation, forward } = parent;

    if (networkError) {
        store.commit('setError', { code: networkError.statusCode, message: networkError.message });
    } else if (graphQLErrors) {
        const message = get(graphQLErrors, '0.message');
        switch (message) {
            case 'Not Found':
                store.commit('setError', { code: 404, message: 'Not Found!' });
                break;

            default:
                store.commit('setError', { code: 400, message: 'Bad API request!' });
        }
    } else {
        store.commit('setError', { code: 500, message: 'An unknown error has occurred!' });
    }

    return forward(operation);
});

const apolloClient = new ApolloClient({
    link: from([networkErrorLink, httpLink]),
    cache: new InMemoryCache(),
    connectToDevTools: process.env.NODE_ENV === 'development',
});

export const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
});

Vue.use(VueApollo);

export default apolloClient;
